import { useState } from 'react';
import { hostUrl } from "../../../../utils/url-manager";

export const useCustomerPasswordResetSender: () => { sendingEmail: boolean, errorMessage: string, successMessage: string, sendEmail: any } =
    ( ): { sendingEmail: boolean, errorMessage: string, successMessage: string, sendEmail: any } => {
    const [sendingEmail, setSendingEmail] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>();
    const [successMessage, setSuccessMessage] = useState<string>();

    function sendEmail(email: string): void {
        if (email === undefined) {
            setErrorMessage('Invalid Customer data');
            return;
        }
        setSendingEmail(true);
        setSuccessMessage(undefined);
        setErrorMessage(undefined);
        const token: string = localStorage.getItem('token');
        const url: string = hostUrl + '';

        const request: Request = new Request(url, {
            method: 'POST',
            body: JSON.stringify({ email: email }),
            headers: new Headers({
                'Content-Type': 'application/json',
                'token': token,
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json()
            } )
            .then ( (data: any): void => {
                setSendingEmail(false);
                if (data?.status === 'success') {
                    setSuccessMessage('Success!');
                }
                if (data?.status === 'error') {
                    setErrorMessage(data?.message);
                }
            } )
            .catch( (err: Error): void => {
                console.log(err)
            })
    }


    return { sendingEmail, errorMessage, successMessage, sendEmail }

}